import { render, staticRenderFns } from "./MultipleQuestion.vue?vue&type=template&id=56e41249&scoped=true&"
import script from "./MultipleQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e41249",
  null
  
)

export default component.exports